import React from 'react';

import {createUseStyles} from 'react-jss'

const CustomStyler = props => {
  console.log(props)
  let styleJson = {
    customWrapper: {
      '& .rcw-header': {},
      '& .rcw-close-button': {},
      '& .rcw-launcher': {},
      '& .rcw-client .rcw-message-text': {}
    }
  }
  if(props.color) {
    //First, determine if this is a 'black' or 'white' color, and set
    //text colors as needed
    //Will need to adjust this for white title text as well
    let backgroundDarkness = lightOrDark(props.color);
    if(backgroundDarkness === 'dark') {
      styleJson.customWrapper['& .rcw-client .rcw-message-text'].color = 'white'
    }
    styleJson.customWrapper['& .rcw-header'].backgroundColor = props.color
    styleJson.customWrapper['& .rcw-close-button'].backgroundColor = props.color
    styleJson.customWrapper['& .rcw-launcher'].backgroundColor = props.color
    styleJson.customWrapper['& .rcw-client .rcw-message-text'].backgroundColor = props.color

  }
  let useStyles = createUseStyles(styleJson);
  const classes = useStyles();
  return (
    <div className={classes.customWrapper}>{props.children}</div>
  )
};

function lightOrDark(color) {

    // Variables for red, green, blue values
    var r, g, b, hsp;

    // Check the format of the color, HEX or RGB?
    if (color.match(/^rgb/)) {

        // If RGB --> store the red, green, blue values in separate variables
        color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);

        r = color[1];
        g = color[2];
        b = color[3];
    }
    else {

        // If hex --> Convert it to RGB: http://gist.github.com/983661
        color = +("0x" + color.slice(1).replace(
        color.length < 5 && /./g, '$&$&'));

        r = color >> 16;
        g = color >> 8 & 255;
        b = color & 255;
    }

    // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
    hsp = Math.sqrt(
    0.299 * (r * r) +
    0.587 * (g * g) +
    0.114 * (b * b)
    );
    console.log(hsp)

    // Using the HSP value, determine whether the color is light or dark
    if (hsp>127.5) {

        return 'light';
    }
    else {

        return 'dark';
    }
}

export default CustomStyler;
